import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import Empresa from "@/pages/Empresa";
import Servicos from "@/pages/Servicos";
import Frota from "@/pages/Frota";
import Projetos from "@/pages/Projetos";
import Experiencia from "@/pages/Experiencia";
import Contactos from "@/pages/Contactos";
import Admin from "@/pages/Admin";
import { LegalPrivacy, LegalCookies, LegalTerms } from "@/pages/Legal";

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
        };
    }, []);

    return (
        <div className="min-h-screen bg-ink text-white">
            <BrowserRouter>
                <ScrollToTop />
                <Header />
                <main>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/empresa" element={<Empresa />} />
                        <Route path="/servicos" element={<Servicos />} />
                        <Route path="/frota" element={<Frota />} />
                        <Route path="/experiencia" element={<Experiencia />} />
                        <Route path="/projetos" element={<Projetos />} />
                        <Route path="/contactos" element={<Contactos />} />
                        <Route path="/admin" element={<Admin />} />
                        <Route path="/privacidade" element={<LegalPrivacy />} />
                        <Route path="/cookies" element={<LegalCookies />} />
                        <Route path="/termos" element={<LegalTerms />} />
                        <Route path="*" element={<Home />} />
                    </Routes>
                </main>
                <Footer />
                <Toaster position="bottom-right" theme="dark" />
            </BrowserRouter>
        </div>
    );
}

export default App;
